import Swiper, { Pagination, Autoplay } from "swiper";

export const initHeroSlider = () => {
  let slider = document.querySelector('.wp-block-hero .swiper')

  if(slider) {
    let count = $('.wp-block-hero .swiper-wrapper').children().length

    if (count > 1) {
      new Swiper(slider, {
        modules: [Pagination, Autoplay],
        centeredSlides: true,
        autoHeight: false,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
          bulletClass: 'h-6 w-6 border-2 border-white rounded-full mx-2 inline-block opacity-70 cursor-pointer',
          bulletActiveClass: 'active border-primary-500 bg-primary-500 h-8 w-8 -mb-1 relative',
          hideOnClick: false,
          horizontalClass: 'relative mx-auto text-center mb-4 z-[1]'
        }
      })
    }
  }
}

export const heroHeading = () => {
  let hero = document.querySelector('.wp-block-hero')

  if(hero) {
    let headings = hero.querySelectorAll('h1')

    headings.forEach((heading) => {
      let string = heading.textContent
      let stringLength = string.length
      heading.textContent = ''

      // Adds green background to hero slogan
      for (let i = 0; i < stringLength; i++) {
        if (string !== '<br>') {
          heading.innerHTML += `<span class="bg-primary-500 relative">${string.charAt(i)}</span>`
        }
      }
    })
  }
}

export const initEditorHeroSlider = () => {
  let hero = document.querySelector('[data-type="acf/hero"]')

  if(hero) {
    let blockWidth = hero.offsetWidth
    let sliders = document.querySelectorAll('[data-type="acf/hero"] .swiper')

    sliders.forEach((slider) => {
      let slides = slider.querySelectorAll('.swiper-slide')
      let wrapper = slider.querySelector('.swiper-wrapper')
      let paginationWrapper = slider.querySelector('.swiper-pagination-wrapper')
      let pagination = slider.querySelector('.swiper-pagination')
      let slidesCount = slides.length

      wrapper.style.width = blockWidth * slidesCount + 'px'

      slides.forEach((slide) => {
        slide.style.float = 'left'
        slide.style.width = blockWidth + 'px'
      })

      pagination.append(...[
        document.createElement('span'),
        document.createElement('span'),
        document.createElement('span')
      ])

      let bullets = pagination.querySelectorAll('span')
      bullets[0].classList.add('active')

      bullets.forEach((bullet, index) => {
        bullet.addEventListener('click', (event) => {
          let distance = blockWidth * index + 1
          wrapper.style.left = - distance + 'px'
          bullets.forEach((bullet) => {
            bullet.classList.remove('active')
          })
          bullet.classList.add('active')
        })
      })
    })
  }
}
